if (!customElements.get('product-comparison-slider')) {
  customElements.define(
    'product-comparison-slider',
    class ProductComparisonSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.product-comparison__track');
        this.prevBtn = this.querySelector('.product-comparison__nav--prev');
        this.nextBtn = this.querySelector('.product-comparison__nav--next');

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.navigate(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.navigate(1));

        this._initDragScroll();

        // Equalize row-value heights so rows align across all slides
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this.equalizeRowHeights());
        } else {
          this.equalizeRowHeights();
        }
        window.addEventListener('resize', FoxTheme.utils.debounce(this.equalizeRowHeights.bind(this), 200));
      }

      _initDragScroll() {
        const track = this.track;
        if (!track) return;

        let isDown = false;
        let startX = 0;
        let scrollLeft = 0;
        let hasDragged = false;

        track.addEventListener('mousedown', (e) => {
          if (e.button !== 0) return;
          isDown = true;
          hasDragged = false;
          startX = e.clientX;
          scrollLeft = track.scrollLeft;
          track.classList.add('is-dragging');
        });

        document.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          const dx = e.clientX - startX;
          if (Math.abs(dx) > 5) hasDragged = true;
          track.scrollLeft = scrollLeft - dx;
        });

        document.addEventListener('mouseup', () => {
          if (!isDown) return;
          isDown = false;
          track.classList.remove('is-dragging');
        });

        // Prevent accidental link/button clicks after a drag
        track.addEventListener('click', (e) => {
          if (hasDragged) {
            e.preventDefault();
            e.stopPropagation();
            hasDragged = false;
          }
        }, true);
      }

      navigate(direction) {
        if (!this.track) return;
        const slide = this.track.querySelector('.product-comparison__slide');
        if (!slide) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({ left: direction * (slide.offsetWidth + gap), behavior: 'smooth' });
      }

      equalizeRowHeights() {
        const slides = Array.from(this.querySelectorAll('.product-comparison__slide'));
        if (slides.length < 2) return;
        const rowCount = slides[0].querySelectorAll('.product-comparison__row-value').length;
        for (let i = 0; i < rowCount; i++) {
          const cells = slides
            .map(slide => slide.querySelectorAll('.product-comparison__row-value')[i])
            .filter(Boolean);
          cells.forEach(cell => (cell.style.minHeight = ''));
          const maxH = Math.max(...cells.map(cell => cell.offsetHeight));
          cells.forEach(cell => (cell.style.minHeight = maxH + 'px'));
        }
      }
    }
  );
}
